import { axiosAjax } from '@app/src/config/axios';
import { DataListModel } from '@app/src/common/PredictiveInput/DataListModel';
import { isClientEnv } from '@app/src/utils/validations';

export const districtService = {
  async get(district: string): Promise<DataListModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_DISTRICT.replace(':districtName', district), config);
      if (data.error) {
        throw new Error();
      }
      return data.data;
    } catch (e) {
      throw new Error(e);
    }
  }
}
